import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './features/dashboard/Dashboard';
import Users from './features/users/Users';
import UserComparison from './features/users/UserComparison';
import Categories from './features/categories/Categories';
import Courses from './features/courses/Courses';
import CourseComparison from './features/courses/CourseComparison';
import Evaluations from './features/evaluations/Evaluations';
import Enrollments from './features/enrollments/Enrollments';
import Monitoring from './features/monitoring/Monitoring';
import Apps from './features/apps/Apps';
import NotificationLogs from './features/notifications/NotificationLogs';
import EmailQueue from './features/emails/EmailQueue';

function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <Router>
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/users/compare" element={<UserComparison />} />
                <Route path="/users" element={<Users />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/courses/compare" element={<CourseComparison />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/evaluations" element={<Evaluations />} />
                <Route path="/enrollments" element={<Enrollments />} />
                <Route path="/notifications" element={<NotificationLogs />} />
                <Route path="/emails" element={<EmailQueue />} />
                <Route path="/monitoring" element={<Monitoring />} />
                <Route path="/apps" element={<Apps />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        </Router>
      </TenantProvider>
    </AuthProvider>
  );
}

export default App;